import { render, staticRenderFns } from "./Pod.vue?vue&type=template&id=47a702f8&scoped=true&"
import script from "./Pod.vue?vue&type=script&lang=js&"
export * from "./Pod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a702f8",
  null
  
)

export default component.exports